import {
  DqCard,
  DqSidePanel,
  DqSidePanelContent,
  DqSidePanelTitle,
} from "@decentriq/components";
import { Divider, Stack } from "@mui/joy";
import { memo } from "react";
import { useLookalikeAdvertiserAudienceGenerator } from "features/mediaDataRoom/containers/LookalikeAdvertiserAudienceGenerator";
import { PositiveCurveScoreBar, PositiveCurveScoreChart } from "./components";

const AudienceQualityStatisticsDrawer = memo(() => {
  const {
    isAdvertiserAudienceQualityDrawerOpen,
    closeAdvertiserAudienceQualityDrawer,
  } = useLookalikeAdvertiserAudienceGenerator();
  return (
    <DqSidePanel
      onClose={closeAdvertiserAudienceQualityDrawer}
      open={isAdvertiserAudienceQualityDrawerOpen}
    >
      <DqSidePanelTitle
        sx={{ alignItems: "center", justifyContent: "space-between" }}
      >
        Recall
      </DqSidePanelTitle>
      <Divider inset="context" />
      <DqSidePanelContent>
        <Stack>
          <DqCard>
            <PositiveCurveScoreBar withChartButton={false} />
          </DqCard>
        </Stack>
        <PositiveCurveScoreChart />
      </DqSidePanelContent>
    </DqSidePanel>
  );
});
AudienceQualityStatisticsDrawer.displayName = "AudienceQualityStatisticsDrawer";

export default AudienceQualityStatisticsDrawer;
